module.exports = __webpack_public_path__ + "static/media/fire1.af1c1ffc.jpg";